import {
  enumUnit,
  SalesItemLineType,
  Unit,
} from '@rematter/frontend-lib-api-client';

import {
  enumLoadWeightType,
  LoadFormLineItem,
} from '~/modules/trade/types/load';
import { SalesOrderLineItemRecord } from '~/modules/trade/types/salesOrder';
import { zeroMoney } from '~/modules/trade/utils/money';

// Convert SalesOrderLineItem to LoadFormLineItem format expected by OrderLineItem
export const convertToLoadFormLineItem = (
  item: SalesOrderLineItemRecord,
): LoadFormLineItem => ({
  id: item.id,
  type: 'Raw' as SalesItemLineType,
  itemId: item.itemId,
  tagId: null,
  unitPrice: item.unitPrice || zeroMoney(),
  estimatedPrice: undefined,
  salesOrderLineId: undefined,
  pricingUnit: (item.unit ?? enumUnit.Pounds) as Unit,
  weights: {
    [enumLoadWeightType.Gross]: null,
    [enumLoadWeightType.Tare]: null,
    [enumLoadWeightType.Net]: {
      value: item.quantity ?? 0,
      unit: (item.unit ?? enumUnit.Pounds) as Unit,
      __typename: 'Weight' as const,
    },
  },
});
